// @ts-check

import { TreeInstance } from "./tree/tree"

/**
 * @type {Tree} blocks
 */
const blocks = [
    {
        id: "container_0",
        type: "container",
        config: {
            style: {},
            attributes: {},
        },
        childBlocks: [
            {
                id: "container_1",
                type: "container",
                config: {
                    style: {},
                    attributes: {
                        direction: "column",
                    },
                },
                childBlocks: [
                    {
                        id: "britain",
                        type: "user",
                        config: {
                            style: {
                                desktop: { background: "#F1F1F1" },
                                tablet: { background: "#E1E1D1" },
                                mobile: { background: "#D1D1B1" },
                            },
                            attributes: {
                                country: "Britain",
                            },
                        },
                        childBlocks: [],
                    },
                    {
                        id: "france",
                        type: "user",
                        config: {
                            style: {
                                desktop: { background: "#F1F1FF" },
                                tablet: { background: "#E1E1D1" },
                                mobile: { background: "#D1D1B1" },
                            },
                            attributes: {
                                country: "France",
                            },
                        },
                        childBlocks: [],
                    },
                    {
                        id: "russia",
                        type: "user",
                        config: {
                            style: {
                                desktop: { background: "#F1F1F1" },
                                tablet: { background: "#E1E1D1" },
                                mobile: { background: "#D1D1B1" },
                            },
                            attributes: {
                                country: "Russia",
                            },
                        },
                        childBlocks: [],
                    },
                ],
            },
            {
                id: "users_0",
                type: "users",
                config: {
                    style: {
                        default: {
                            background: "#F1F1F1",
                        },
                        mobile: {
                            color: "pink",
                        },
                    },
                    attributes: {},
                },
            },
        ],
    },
]

const newBlocks = [
    {
        id: "container_0",
        type: "container",
        config: {
            attributes: {
                direction: "column",
            },
            style: {
                default: {
                    height: "80vh",
                },
            },
        },
        childBlocks: [
            {
                id: "empty_green",
                type: "string",
                config: {
                    attributes: {},
                    style: {
                        default: {
                            background: "green",
                        },
                    },
                },
                childBlocks: [],
            },
            {
                id: "empty_blue",
                type: "string",
                config: {
                    attributes: {},
                    style: {
                        default: {
                            background: "blue",
                        },
                    },
                },
                childBlocks: [],
            },
            {
                id: "empty_red",
                type: "string",
                config: {
                    attributes: {},
                    style: {
                        default: {
                            background: "red",
                        },
                    },
                },
                childBlocks: [],
            },
            {
                id: "empty_pink",
                type: "string",
                config: {
                    attributes: {},
                    style: {
                        default: {
                            background: "pink",
                        },
                    },
                },
                childBlocks: [],
            },
            {
                id: "empty_magenta",
                type: "string",
                config: {
                    attributes: {},
                    style: {
                        default: {
                            background: "magenta",
                        },
                    },
                },
                childBlocks: [],
            },
            {
                id: "empty_orange",
                type: "string",
                config: {
                    attributes: {},
                    style: {
                        default: {
                            background: "orange",
                        },
                    },
                },
                childBlocks: [],
            },
        ],
    },
]

const realBlocks = [
    {
        id: "container_0",
        type: "container",
        config: {
            attributes: {},
            style: {},
        },
        childBlocks: [
            {
                id: "form_0",
                type: "form",
                config: {
                    attributes: {},
                    style: {},
                },
            },
            {
                id: "debug_property_0",
                type: "debug_property",
                config: {
                    style: {
                        default: {
                            background: "#F1F1F1",
                        },
                        mobile: {
                            color: "pink",
                        },
                    },
                    attributes: {
                        property: {
                            id: "input_0.property.inputValue",
                        },
                        action: {
                            id: "form_0.action.submit",
                        },
                    },
                },
            },
            {
                id: "button_0",
                type: "button",
                config: {
                    attributes: {
                        type: "primary",
                        buttonTitle: "hey",
                    },
                    style: {
                        default: {
                            flexBasis: "30px",
                        },
                    },
                },
                childBlocks: [],
            },
            {
                id: "input_0",
                type: "input",
                config: {
                    attributes: {
                        placeholder: "hey, my input",
                        "broadcast.property.inputValue": "myOwnName",
                    },
                    style: {},
                },
                childBlocks: [],
            },
            {
                id: "input_1",
                type: "input",
                config: {
                    attributes: {
                        placeholder: "Your name",
                    },
                    style: {},
                },
                childBlocks: [],
            },
            {
                id: "card_0",
                type: "card",
                config: {
                    attributes: {},
                    style: {},
                },
                childBlocks: [],
            },
        ],
    },
]

const emptyPage = [
    {
        id: "page",
        type: "container",
        config: {
            attributes: {
                label: "Page",
                direction: "column"
            },
            style: {
                default: {
                    backgroundColor: "#f9f9f9",
                    width: "100%",
                    height: "100%",
                    justifyContent: "flex-start",
                    margin: "0px auto",
                    flexGrow: 0,
                },
            },
        },
        childBlocks: [
            {
                id: "center_content",
                type: "container",
                config: {
                    attributes: {
                        label: "Center Content",
                        direction: "column",
                    },
                    style: {
                        default: {
                            width: "100%",
                            maxWidth: "1000px",
                            minHeight: "50px",
                            margin: "0px auto",
                            flexGrow: "0",
                            paddingBottom: "30px",
                        },
                    },
                },
                childBlocks: [
                    {
                        "id": "text_0",
                        "type": "string",
                        "config": {
                            "attributes": {
                                "label": "Text",
                                "text": "Your page goes here!"
                            },
                            "style": {
                                "default": {
                                    "fontSize": "36pt",
                                    "marginTop": "50px",
                                    "marginLeft": "25px"
                                }
                            },
                            "broadcast": []
                        },
                        "childBlocks": []
                    },
                ],
            },
        ],
    },
]

const customBlock = [
    {
        id: "page",
        type: "container",
        config: {
            style: {
                default: {
                    width: "300px",
                    height: "200px",
                    margin: "0px auto",
                    flexGrow: 0,
                    justifyContent: "flex-start",
                    backgroundColor: "#f9f9f9",
                },
            },
            broadcast: [],
            attributes: {
                label: "Block",
                direction: "column"
            },
        },
        childBlocks: [
        ],
    },
]

export default {
    colorBlocks: new TreeInstance(newBlocks),
    countryBlocks: new TreeInstance(blocks),
    realBlocks: new TreeInstance(realBlocks),
    emptyPage: new TreeInstance(emptyPage),
    customBlock: new TreeInstance(customBlock),
}



// WEBPACK FOOTER //
// ./src/features/editor/defaultTree.js